import { useEffect, useState } from "react";

export function useCurrentTrack(token: string | null) {
  const [track, setTrack] = useState<any>(null);

  useEffect(() => {
    if (!token) return;
    let interval: NodeJS.Timeout;
    let isActive = true;

    const fetchTrack = async () => {
      if (!isActive) return;
      try {
        const res = await fetch(
          "https://api.spotify.com/v1/me/player/currently-playing",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (res.status === 204) {
          setTrack(null);
          return;
        }

        if (res.ok) {
          const text = await res.text();
          setTrack(text ? JSON.parse(text) : null);
          return;
        }

        if (res.status === 401) {
          // Clear token on 401 Unauthorized
          localStorage.removeItem("spotify_token");
        }
        setTrack(null);
      } catch {
        setTrack(null);
      }
    };

    // Function to handle tab visibility change
    const handleVisibility = () => {
      isActive = !document.hidden;
      if (isActive) {
        fetchTrack();
        interval = setInterval(fetchTrack, 15000); // 15 seconds
      } else {
        clearInterval(interval);
      }
    };

    fetchTrack();
    interval = setInterval(fetchTrack, 15000); // 15 seconds
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [token]);

  return track;
}
